import { useAbTest } from 'ab-test/hooks/useAbTest/useAbTest'
import { AbTestKeys } from 'types/constants/AbTestKeys'
import { AccountActions } from '../AccountActions/AccountActions'
import { AccountLink } from '../AccountLink/AccountLink'

export function AccountActionsWrapper({
	hasFavorites,
}: {
	readonly hasFavorites: boolean
}) {
	const deleteUserMenuTooltip = useAbTest({
		key: AbTestKeys.DeleteUserMenuTooltip,
		defaultDecision: { enabled: true },
	})

	if (deleteUserMenuTooltip?.enabled) {
		return <AccountLink />
	}

	return <AccountActions hasFavorites={hasFavorites} />
}
